// import { SortableElement, sortableHandle } from 'react-sortable-hoc';

import React, { useState } from 'react';
import { Form, Input, Checkbox } from 'antd';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Toast } from '@components';
import { Button, Animations } from 'appkit-react';
import { deleteMarkFromKeyName } from './formUtils';
import { connect } from 'react-redux';
import action from '@flux/action';

const contentStyles = {
  width: 580,
  height: 185,
  padding: 0,
};

// Create context for sharing drag handlers
const DragContext = React.createContext({});

// Replacement for sortableHandle - creates a HOC that returns a draggable component
const sortableHandle = (Component) =>
  React.forwardRef((props, ref) => {
    const { listeners, attributes } = React.useContext(DragContext);
    return (
      <Component
        {...props}
        ref={ref}
        {...listeners}
        {...attributes}
        style={{ cursor: 'grab' }}
      />
    );
  });

// Create a wrapper component that uses the hook
// Create a wrapper component that uses the hook
const SortableWrapper = ({ children, id, ...props }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <DragContext.Provider value={{ listeners, attributes }}>
      <div ref={setNodeRef} style={style}>
        {children}
      </div>
    </DragContext.Provider>
  );
};

// Replacement for SortableElement - creates a HOC that makes the component sortable
const SortableElement = (Component) => (props) => {
  const id = props.field?.key || props.field?.name || props.id;

  return (
    <SortableWrapper id={id} {...props}>
      <Component {...props} />
    </SortableWrapper>
  );
};

const DragHandle = sortableHandle(() => (
  <span className="appkiticon icon-menu-outline" style={{ flex: 1 }} />
));

const SortableItem = SortableElement((props) => {
  const {
    field = {},
    type,
    remove,
    bodyContentList = {},
    propsAnimation,
    form,
    keyContactsData = {},
    saveKeyContactsData,
  } = props;
  const [isShow, setIsShow] = useState(false);
  const [isAnimation, setIsAnimation] = useState(propsAnimation);
  const [animationType] = useState('bounceInRight');

  const Delete = ({ value }) =>
    value ? null : (
      <span
        className="appkiticon icon-circle-delete-fill"
        onClick={(e) => {
          setIsShow(true);
        }}
      />
    );

  return (
    <div>
      <Toast
        isShow={isShow}
        contentStyles={contentStyles}
        content={
          <div>
            <div className="conten-up">
              <span className="warning-icon">WARNING</span>
              Do you confirm to delete this item?
              <span
                className="appkiticon icon-close-outline"
                onClick={() => setIsShow(false)}
              />
            </div>
            <div className="conten-down">
              <div className="btn-box">
                <Button
                  className="cancel"
                  kind="second"
                  onClick={() => setIsShow(false)}
                >
                  cancel
                </Button>{' '}
                <Button
                  className="delete"
                  onClick={async () => {
                    await remove(field.name);
                    if (type === '2') {
                      saveKeyContactsData({
                        ...keyContactsData,
                        target: deleteMarkFromKeyName(
                          form.getFieldsValue(),
                          '2',
                        ),
                      });
                    } else {
                      saveKeyContactsData({
                        ...keyContactsData,
                        buyer: deleteMarkFromKeyName(
                          form.getFieldsValue(),
                          '1',
                        ),
                      });
                    }
                    setIsShow(false);
                  }}
                >
                  delete
                </Button>
              </div>
            </div>
          </div>
        }
      />
      <Animations
        effect={animationType}
        active={isAnimation}
        afterAnimation={() => {
          setIsAnimation(false);
        }}
      >
        <div className="body-row" style={{ display: 'flex' }} key={field.key}>
          <DragHandle />
          <Form.Item
            className={`need-margin ${
              bodyContentList[`executives${type}`] &&
              bodyContentList[`executives${type}`][field.name]?.isFromCraft &&
              'color-grey'
            }`}
            style={{ flex: 5 }}
            {...field}
            name={[field.name, 'name']}
            fieldKey={[field.fieldKey, 'name']}
            rules={[
              {
                required: true,
                whitespace: true,
                message: 'Name is required!',
              },
            ]}
          >
            <Input
              disabled={
                bodyContentList[`executives${type}`] &&
                bodyContentList[`executives${type}`][field.name]?.isFromCraft
              }
            />
          </Form.Item>
          <Form.Item
            className={`${
              bodyContentList[`executives${type}`] &&
              bodyContentList[`executives${type}`][field.name]?.isFromCraft &&
              'color-grey'
            }`}
            style={{ flex: 4.5 }}
            name={[field.name, 'title']}
            fieldKey={[field.fieldKey, 'title']}
            rules={[
              {
                required: true,
                whitespace: true,
                message: 'Title is required!',
              },
            ]}
          >
            <Input
              disabled={
                bodyContentList[`executives${type}`] &&
                bodyContentList[`executives${type}`][field.name]?.isFromCraft
              }
            />
          </Form.Item>
          <Form.Item
            valuePropName="checked"
            className="check-box-item"
            name={[field.name, 'shouldDisplay']}
            fieldKey={[field.fieldKey, 'shouldDisplay']}
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            style={{ flex: 6 }}
            name={[field.name, 'linkedin']}
            fieldKey={[field.fieldKey, 'linkedin']}
          >
            <Input />
          </Form.Item>
          <Form.Item
            style={{ flex: 1 }}
            name={[field.name, 'isFromCraft']}
            fieldKey={[field.fieldKey, 'isFromCraft']}
          >
            {bodyContentList[`executives${type}`] &&
            !bodyContentList[`executives${type}`][field.name]?.isFromCraft ? (
              <Delete />
            ) : null}
          </Form.Item>
        </div>
      </Animations>
    </div>
  );
});

const mapStateToProps = ({ analysis }) => ({
  keyContactsData: analysis.keyContactsData,
});

const mapDispatchToProps = (dispatch) => ({
  saveKeyContactsData(data) {
    dispatch(action.saveKeyContactsData(data));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(SortableItem));
